<p-toolbar>
  <div class="ui-left">
    @if (!isMobile) {
      @if (isZoomTarget) {
        <button
          class="p-menu-bar-button"
          icon="icon-table"
          iuKeybinding
          iuKeybinding-code="menu-bar-detail.zoom"
          iuKeybinding-event-mode="mouseup"
          pButton
          showDelay="250"
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [iuKeybinding-active]="activateKeybind && !isSplitView"
          [iuKeybinding-focusTab]="activeTabID"
          [life]="3000"
          pTooltip="{{ 'menuBarDetails.zoom' | translate }}"
          (mouseup)="changeGridViewVisibility && $event.button === 0 ? changeGridViewVisibility.emit($event) : ''">
          {{ '' }}
        </button>
      }
      <button
        class="p-menu-bar-button"
        data-cy="button-newRecord"
        icon="icon-add"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.new"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [disabled]="!newBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.add' | translate }}"
        (mouseup)="newEvent && $event.button === 0 ? newEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-saveRecord"
        icon="icon-save3x"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.save"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [disabled]="!saveBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.save' | translate }}"
        (mouseup)="saveEvent && $event.button === 0 ? saveEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-refresh"
        icon="icon-refresh3x"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.refresh"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [disabled]="!refreshBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.refresh' | translate }}"
        (mouseup)="refreshEvent && $event.button === 0 ? refreshEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-delete"
        icon="icon-delete"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.delete"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [disabled]="!deleteBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.delete' | translate }}"
        (mouseup)="deleteEvent && $event.button === 0 ? deleteEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-copy"
        icon="icon-copy"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.copy"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [disabled]="!copyBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.copy' | translate }}"
        (mouseup)="copyEvent && $event.button === 0 ? copyEvent.emit($event) : ''">
        {{ '' }}
      </button>
    } @else {
      <button
        class="p-menu-bar-button"
        data-cy="menuBar-showButtons-btn"
        icon="icon-menu-bars"
        pButton
        showDelay="250"
        tooltipPosition="top"
        type="button"
        [attr.data-cy-toggle-state]="showMoreAction ? 'opened' : 'closed'"
        [hideDelay]="250"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.showButtons' | translate }}"
        (mouseup)="showMoreActionEmitter.emit($event)">
        {{ '' }}
      </button>
    }
  </div>

  <div class="ui-center">
    @if (!isZoomEditView && !isZoomTarget && arrowsDisplayed) {
      <span
        class="arrow back-arrow icon-back"
        iuKeybinding
        iuKeybinding-event-mode="mouseup"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-code]="'menu-bar-detail.back'"
        [iuKeybinding-focusTab]="activeTabID"
        [iuKeybinding-shift]="false"
        (click)="changeGridElementEvent.emit(-1)"></span>
    }
    <span
      class="tabTitle"
      data-cy="show-changelog"
      showDelay="250"
      tooltipPosition="top"
      [hideDelay]="250"
      [life]="3000"
      pTooltip="{{ viewRecordChangeLogLabel }}"
      (click)="viewRecordChangeLog.emit($event)">
      {{ viewRecordChangeLogLabel | slice: 0 : (!isMobile ? 28 : 20) }}
    </span>
    <span class="newSymbol">{{ status === 'sync' ? '' : ' *' }}</span>
    @if (!isZoomEditView && !isZoomTarget && arrowsDisplayed) {
      <span
        class="arrow next-arrow icon-next"
        iuKeybinding
        iuKeybinding-event-mode="mouseup"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-code]="'menu-bar-detail.next'"
        [iuKeybinding-focusTab]="activeTabID"
        [iuKeybinding-shift]="false"
        (click)="changeGridElementEvent.emit(1)"></span>
    }
  </div>

  <div class="ui-right">
    @if (!isMobile) {
      <button
        class="p-menu-bar-button"
        data-cy="button-email"
        icon="icon-mail"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.email"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [disabled]="!mailBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.email' | translate }}"
        (mouseup)="emailEvent && $event.button === 0 ? emailEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-note"
        icon="icon-notes"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.note"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [disabled]="!noteBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.note' | translate }}"
        (mouseup)="noteEvent && $event.button === 0 ? noteEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-request"
        icon="icon-document"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.request"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        style="overflow: visible"
        tooltipPosition="left"
        type="button"
        [disabled]="!requestBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.request' | translate }}"
        (mouseup)="requestEvent && $event.button === 0 ? requestEvent.emit($event) : ''">
        @if (nbRequest !== undefined && nbRequest > 0) {
          <span class="iupics-badge iupics-badge-count" style="top: 0; right: -2px">{{
            nbRequest > 9 ? '9+' : nbRequest
          }}</span>
        }
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-attachFile"
        icon="icon-attach3x"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.join"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        style="overflow: visible"
        tooltipPosition="left"
        type="button"
        [disabled]="!joinFileBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.joinFiles' | translate }}"
        (mouseup)="joinFilesEvent && $event.button === 0 ? joinFilesEvent.emit($event) : ''">
        @if (nbUploadedFiles !== undefined && nbUploadedFiles > 0) {
          <span class="iupics-badge iupics-badge-count" style="top: 0; right: -2px">{{
            nbUploadedFiles > 9 ? '9+' : nbUploadedFiles
          }}</span>
        }
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-export"
        icon="icon-export"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.export"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [disabled]="!exportBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.export' | translate }}"
        (mouseup)="exportDataEvent && $event.button === 0 ? exportDataEvent.emit($event) : ''">
        {{ '' }}
      </button>
      <button
        class="p-menu-bar-button"
        data-cy="button-print"
        icon="icon-print"
        iuKeybinding
        iuKeybinding-code="menu-bar-detail.print"
        iuKeybinding-event-mode="mouseup"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [disabled]="!printBtnCondition"
        [hideDelay]="250"
        [iuKeybinding-active]="activateKeybind && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.print' | translate }}"
        (mouseup)="printEvent && $event.button === 0 ? printEvent.emit($event) : ''">
        {{ '' }}
      </button>
    }
    <button
      class="p-menu-bar-button"
      data-cy="button-closeBlade"
      icon="icon-close"
      iuKeybinding
      iuKeybinding-code="menu-bar-detail.close"
      iuKeybinding-event-mode="mouseup"
      pButton
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="activateKeybind && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ 'menuBarDetails.close' | translate }}"
      (mouseup)="$event.button === 0 ? closeEvent.emit($event) : ''">
      {{ '' }}
    </button>
  </div>
</p-toolbar>

@if (showMoreAction) {
  <div class="more-action">
    @if (isZoomTarget) {
      <button
        class="p-menu-bar-button"
        icon="icon-table"
        pButton
        type="button"
        (mouseup)="changeGridViewVisibility ? changeGridViewVisibility.emit($event) : ''">
        {{ '' }}
      </button>
    }
    <button
      class="p-menu-bar-button"
      data-cy="button-newRecord"
      icon="icon-add"
      pButton
      type="button"
      [disabled]="!newBtnCondition"
      (mouseup)="newEvent ? newEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-saveRecord"
      icon="icon-save3x"
      pButton
      type="button"
      [disabled]="!saveBtnCondition"
      (mouseup)="saveEvent ? saveEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-refresh"
      icon="icon-refresh3x"
      pButton
      type="button"
      [disabled]="!refreshBtnCondition"
      (mouseup)="refreshEvent ? refreshEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-delete"
      icon="icon-delete"
      pButton
      type="button"
      [disabled]="!deleteBtnCondition"
      (mouseup)="deleteEvent ? deleteEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-copy"
      icon="icon-copy"
      pButton
      type="button"
      [disabled]="!copyBtnCondition"
      (mouseup)="copyEvent ? copyEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-email"
      icon="icon-mail"
      pButton
      type="button"
      [disabled]="!mailBtnCondition"
      (mouseup)="emailEvent ? emailEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button notes-button"
      data-cy="button-note"
      icon="icon-notes"
      pButton
      type="button"
      [disabled]="!noteBtnCondition"
      (mouseup)="noteEvent && $event.button === 0 ? noteEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-attachFile"
      icon="icon-attach3x"
      pButton
      type="button"
      [disabled]="!joinFileBtnCondition"
      (mouseup)="joinFilesEvent ? joinFilesEvent.emit($event) : ''">
      @if (nbUploadedFiles !== undefined && nbUploadedFiles > 0) {
        <span class="iupics-badge iupics-badge-count">{{ nbUploadedFiles > 9 ? '9+' : nbUploadedFiles }}</span>
      }
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-export"
      icon="icon-export"
      pButton
      type="button"
      [disabled]="!exportBtnCondition"
      (mouseup)="exportDataEvent ? exportDataEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      data-cy="button-print"
      icon="icon-print"
      pButton
      type="button"
      [disabled]="!printBtnCondition"
      (mouseup)="printEvent ? printEvent.emit($event) : ''">
      {{ '' }}
    </button>
    <button class="p-menu-bar-button" icon="icon-close" pButton type="button" (mouseup)="closeEvent.emit($event)">
      {{ '' }}
    </button>
  </div>
}
